import client from './client'
import { AxiosPromise } from 'axios'

import { Prescription } from '../types/models/Presc'

export const getPrescriptions = (): AxiosPromise<Prescription[]> =>
  client.get('/prescriptions')

// NOTE: getAnnotatePrescList is annotator-only API, moved to apps/annotator/apis/prescription.ts

export const changeFavoriteStatus = (
  prescId: string,
  isFavorite: boolean
): AxiosPromise => {
  const params = { isFavorite }
  return client.post(`prescriptions/${prescId}/is_favorite/`, params)
}

export const createPrescription = (images: string[]): AxiosPromise<string> => {
  const formData = new FormData()
  images.forEach((image, index) => {
    formData.append(`images[${index}]`, image)
  })
  return client.post('/request_event/', formData)
}

export const generateCsv = (prescId: string): AxiosPromise<void> => {
  return client.post<void>(`prescriptions/${prescId}/generate_csv/`)
}
